import { useEffect, useState } from "react";
import { GetAllTeleCallerWithParent } from "../../services/sideBar";

const TeleCaller = ({ selectedUsers, setSelectedUsers }) => {
    const [userData, setUserData] = useState([]);
    const [loading, setLoading] = useState(false);
    // console.log("se", selectedUsers);
    // console.log("setse", setSelectedUsers);

    // const isUserSelected = (userId) => {
    //     return selectedUsers.some(
    //         (item) => Number(item.id) === Number(userId)
    //     );
    // };

    useEffect(() => {
        const fetchTelecaller = async () => {
            setLoading(true);

            try {
                const response = await GetAllTeleCallerWithParent();
                //console.log("tele", response);
                if (response?.success) {
                    setUserData(response.data || []);
                }
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        };

        fetchTelecaller();
    }, []);

    // Single Checkbox
  const handleCheckbox = (userId) => {
    userId = Number(userId);

    setSelectedUsers((prev) =>
        prev.includes(userId)
            ? prev.filter((id) => id !== userId)
            : [...prev, userId]
    );
};

    // Select All
    const handleSelectAll = (users, checked) => {
    const ids = users.map((u) => Number(u.userId));

    if (checked) {
        setSelectedUsers((prev) => [
            ...new Set([...prev, ...ids])
        ]);
    } else {
        setSelectedUsers((prev) =>
            prev.filter((id) => !ids.includes(Number(id)))
        );
    }
};

    // Check if all selected
   const isAllSelected = (users) => {
    if (!users.length) return false;

    return users.every((user) =>
        selectedUsers.includes(Number(user.userId))
    );
};

    if (loading) {
        return <p>Loading...</p>;
    }

    return (
        <div className="card shadow">
            <div className="card-header bg-primary text-white">
                <h5 className="mb-0">Select Follow-up Users</h5>
            </div>

            <div className="card-body">
                {userData.length === 0 ? (
                    <p className="text-muted">No users found.</p>
                ) : (
                    userData.map((group, index) => (
                        <div key={index} className="mb-4 border-bottom pb-3">

                            {/* Parent User */}
                            <div className="d-flex align-items-center mb-2">
                                <h6 className="text-primary me-3 mb-0">
                                    {group.parentUserName}
                                </h6>

                                <div className="form-check">
                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id={`select-all-${index}`}
                                        checked={isAllSelected(group.users)}
                                        onChange={(e) =>
                                            handleSelectAll(
                                                group.users,
                                                e.target.checked
                                            )
                                        }
                                    />

                                    <label
                                        className="form-check-label"
                                        htmlFor={`select-all-${index}`}
                                    >
                                        Select All
                                    </label>
                                </div>
                            </div>

                            {/* Users */}
                            <div className="row">
                                {group.users.map((user) => {
                                    const userId = Number(user.userId);
console.log("API User:", user);
console.log("userId:", Number(user.userId));
                                    return (
                                        <div
                                            className="col-md-4 mb-2"
                                            key={userId}
                                        >
                                            <div className="form-check">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                     id={`user-${userId}`}
                        checked={selectedUsers.includes(Number(user.userId))}
                        onChange={() => handleCheckbox(Number(user.userId))}
                                                />

                                                <label
                                                    className="form-check-label"
                                                    htmlFor={`user-${userId}`}
                                                >
                                                    {user.userName}
                                                </label>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>

                        </div>
                    ))
                )}
            </div>
        </div>
    );
};

export default TeleCaller;